import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';

/** Contract of the page and the worker for signing out. */
export const logoutContract = defineChannelContract<{
  requests: {
    /** Resolves once the worker dropped the user's data. */
    logout: { request: undefined; response: void };
  };
  events: {
    /** The worker signs out: every tab signs out too. */
    [DomainMessagesTypes.logout]: undefined;
  };
}>('logoutChannel');
